import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const tealBorder = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: `1px solid ${tealBorder}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const labelStyle = {
  fontWeight: 600,
  color: "#334155",
  fontSize: "14px",
  marginBottom: "6px",
};

export default function BulkOrder() {
  const [configOpen, setConfigOpen] = useState(true);
  const [action, setAction] = useState("switch"); // "switch" | "redemption"
  const [fund, setFund] = useState("");
  const [fromScheme, setFromScheme] = useState("");
  const [category, setCategory] = useState("equity"); // "equity" | "debt" | "liquid" | "other"
  const [targetScheme, setTargetScheme] = useState("");

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Bulk Order</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/invest-bse/profile-list">Invest Online BSE</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Bulk Order
                </li>
              </ol>
            </nav>
          </div>

          {/* Page title */}
          <h1 style={{ fontSize: "22px", fontWeight: 700, color: "#334155", marginBottom: "12px" }}>
            Do Bulk Switch or Redemptions
          </h1>
          <p style={{ color: "#64748b", fontSize: "14px", marginBottom: "24px", lineHeight: 1.6 }}>
            View investors in a scheme and do bulk transaction for all UNIT for the selected folio. Exit load and tax implications will be as usual. Only Clients with Active Online Account will be displayed.
          </p>

          {/* Collapsible Report Configuration */}
          <div style={cardStyle}>
            <button
              type="button"
              onClick={() => setConfigOpen(!configOpen)}
              className="d-flex align-items-center justify-content-between w-100 border-0 bg-transparent p-0"
              style={{
                cursor: "pointer",
                paddingBottom: configOpen ? "16px" : 0,
                marginBottom: configOpen ? 0 : 0,
              }}
              aria-expanded={configOpen}
            >
              <span style={{ fontWeight: 700, color: "#334155", fontSize: "16px" }}>
                Report Configuration
              </span>
              <i
                className={`fa fa-${configOpen ? "minus" : "plus"}`}
                style={{ color: "#64748b", fontSize: "14px" }}
                aria-hidden
              />
            </button>

            {configOpen && (
              <div className="pt-2">
                {/* Row 1: Action */}
                <div className="row g-3 mb-3">
                  <div className="col-12 col-md-6">
                    <div style={labelStyle}>Action:</div>
                    <div className="d-flex gap-4">
                      <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="action"
                          checked={action === "switch"}
                          onChange={() => setAction("switch")}
                          style={{ accentColor: "#10b981" }}
                        />
                        Switch
                      </label>
                      <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="action"
                          checked={action === "redemption"}
                          onChange={() => setAction("redemption")}
                          style={{ accentColor: "#10b981" }}
                        />
                        Redemption
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-md-6" />
                </div>

                {/* Row 2: Fund, From Scheme */}
                <div className="row g-3 mb-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-semibold text-secondary mb-1 d-block">Fund</label>
                    <select
                      value={fund}
                      onChange={(e) => setFund(e.target.value)}
                      style={inputStyle}
                    >
                      <option value="">Select</option>
                      <option value="equity">Equity</option>
                      <option value="debt">Debt</option>
                      <option value="hybrid">Hybrid</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-semibold text-secondary mb-1 d-block">From Scheme</label>
                    <input
                      type="text"
                      placeholder="Type to Search..."
                      value={fromScheme}
                      onChange={(e) => setFromScheme(e.target.value)}
                      style={inputStyle}
                    />
                  </div>
                </div>

                {/* Row 3: Category, Target Scheme */}
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <div style={labelStyle}>Category:</div>
                    <div className="d-flex flex-wrap gap-3">
                      {[
                        { value: "equity", label: "Equity" },
                        { value: "debt", label: "Debt" },
                        { value: "liquid", label: "Liquid" },
                        { value: "other", label: "Other" },
                      ].map(({ value, label }) => (
                        <label key={value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                          <input
                            type="radio"
                            name="category"
                            checked={category === value}
                            onChange={() => setCategory(value)}
                            style={{ accentColor: "#10b981" }}
                          />
                          {label}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-semibold text-secondary mb-1 d-block">Target Scheme</label>
                    <input
                      type="text"
                      placeholder="Type to Search..."
                      value={targetScheme}
                      onChange={(e) => setTargetScheme(e.target.value)}
                      style={inputStyle}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
